import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { UserStore } from '../services/user-store.service';

/** Célula y Tomar lista no aplican cuando el super está viendo otra iglesia. */
export const propiaCelulaGuard: CanActivateFn = () => {
  const userStore = inject(UserStore);
  const router = inject(Router);

  if (userStore.vistaIglesia()) {
    return router.createUrlTree(['/congregacion']);
  }

  return true;
};
